/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { EntryFeeUnit } from './EntryFeeUnit';
import {
    EntryFeeUnitFromJSON,
    EntryFeeUnitFromJSONTyped,
    EntryFeeUnitToJSON,
    EntryFeeUnitToJSONTyped,
} from './EntryFeeUnit';
import type { TournamentPrizeSplit } from './TournamentPrizeSplit';
import {
    TournamentPrizeSplitFromJSON,
    TournamentPrizeSplitFromJSONTyped,
    TournamentPrizeSplitToJSON,
    TournamentPrizeSplitToJSONTyped,
} from './TournamentPrizeSplit';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { BracketType } from './BracketType';
import {
    BracketTypeFromJSON,
    BracketTypeFromJSONTyped,
    BracketTypeToJSON,
    BracketTypeToJSONTyped,
} from './BracketType';
import type { TournamentPrizePoolInput } from './TournamentPrizePoolInput';
import {
    TournamentPrizePoolInputFromJSON,
    TournamentPrizePoolInputFromJSONTyped,
    TournamentPrizePoolInputToJSON,
    TournamentPrizePoolInputToJSONTyped,
} from './TournamentPrizePoolInput';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';
import type { TournamentBracketSettingsInput } from './TournamentBracketSettingsInput';
import {
    TournamentBracketSettingsInputFromJSON,
    TournamentBracketSettingsInputFromJSONTyped,
    TournamentBracketSettingsInputToJSON,
    TournamentBracketSettingsInputToJSONTyped,
} from './TournamentBracketSettingsInput';
import type { TournamentCurrency } from './TournamentCurrency';
import {
    TournamentCurrencyFromJSON,
    TournamentCurrencyFromJSONTyped,
    TournamentCurrencyToJSON,
    TournamentCurrencyToJSONTyped,
} from './TournamentCurrency';
import type { EntryFeeConfig } from './EntryFeeConfig';
import {
    EntryFeeConfigFromJSON,
    EntryFeeConfigFromJSONTyped,
    EntryFeeConfigToJSON,
    EntryFeeConfigToJSONTyped,
} from './EntryFeeConfig';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface CreateTournamentBody
 */
export interface CreateTournamentBody {
    /**
     * Parent challenge ID (optional)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTournamentBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTournamentBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTournamentBody
     */
    gameId?: string;
    /**
     * 
     * @type {BracketType}
     * @memberof CreateTournamentBody
     */
    bracketType: BracketType;
    /**
     * 
     * @type {number}
     * @memberof CreateTournamentBody
     */
    teamSize: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTournamentBody
     */
    maxTeams: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTournamentBody
     */
    minTeams?: number;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof CreateTournamentBody
     */
    entryType?: CompetitionEntryType;
    /**
     * 
     * @type {EntryFeeConfig}
     * @memberof CreateTournamentBody
     */
    entryFeeConfig?: EntryFeeConfig;
    /**
     * Prizes only pay out if at least this many competed. Distinct from minTeams, which gates whether the tournament can start.
     * @type {number}
     * @memberof CreateTournamentBody
     */
    minParticipants?: number;
    /**
     * Entry fee in FUEL (0 for free). Legacy create path — prefer entryFeeConfig, which is authoritative when supplied.
     * @type {number}
     * @memberof CreateTournamentBody
     */
    entryFee?: number;
    /**
     * 
     * @type {TournamentPrizePoolInput}
     * @memberof CreateTournamentBody
     */
    prizePool?: TournamentPrizePoolInput;
    /**
     * Unix timestamp (ms)
     * @type {number}
     * @memberof CreateTournamentBody
     */
    registrationOpens: number;
    /**
     * Unix timestamp (ms)
     * @type {number}
     * @memberof CreateTournamentBody
     */
    registrationCloses: number;
    /**
     * Unix timestamp (ms)
     * @type {number}
     * @memberof CreateTournamentBody
     */
    startTime: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTournamentBody
     */
    rules?: string;
    /**
     * 
     * @type {TournamentBracketSettingsInput}
     * @memberof CreateTournamentBody
     */
    bracketSettings?: TournamentBracketSettingsInput;
    /**
     * Parent competition ID (optional)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    competitionId?: string;
    /**
     * Sponsor/brand ID (optional)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    brandId?: string;
    /**
     * 
     * @type {TournamentCurrency}
     * @memberof CreateTournamentBody
     */
    entryFeeCurrency?: TournamentCurrency;
    /**
     * 
     * @type {EntryFeeUnit}
     * @memberof CreateTournamentBody
     */
    entryFeeUnit?: EntryFeeUnit;
    /**
     * Fee modes a captain may choose from at registration
     * @type {Array<TournamentFeeMode>}
     * @memberof CreateTournamentBody
     */
    allowedFeeModes?: Array<TournamentFeeMode>;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof CreateTournamentBody
     */
    feeMode?: TournamentFeeMode;
    /**
     * 
     * @type {TournamentPrizeSplit}
     * @memberof CreateTournamentBody
     */
    prizeSplit?: TournamentPrizeSplit;
    /**
     * Reference to a payout table configuration
     * @type {string}
     * @memberof CreateTournamentBody
     */
    payoutTableId?: string;
    /**
     * Per-competition jurisdiction override. Evaluated ALONGSIDE the type default, never instead of it, so it can only tighten. Omit to inherit the default for this type and entry kind.
     * @type {string}
     * @memberof CreateTournamentBody
     */
    jurisdictionPolicyId?: string;
    /**
     * Primary platform for the tournament
     * @type {string}
     * @memberof CreateTournamentBody
     */
    platform?: CreateTournamentBodyPlatformEnum;
    /**
     * Primary region for the tournament
     * @type {string}
     * @memberof CreateTournamentBody
     */
    region?: CreateTournamentBodyRegionEnum;
    /**
     * Tournament visibility
     * @type {string}
     * @memberof CreateTournamentBody
     */
    privacy?: CreateTournamentBodyPrivacyEnum;
    /**
     * Skill level requirement
     * @type {string}
     * @memberof CreateTournamentBody
     */
    skillLevel?: CreateTournamentBodySkillLevelEnum;
    /**
     * Minimum age requirement (0 for no restriction)
     * @type {number}
     * @memberof CreateTournamentBody
     */
    ageRestriction?: number;
    /**
     * Whether check-in is required before tournament starts
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    checkInRequired?: boolean;
    /**
     * Minutes before start time when check-in opens
     * @type {number}
     * @memberof CreateTournamentBody
     */
    checkInWindowMinutes?: number;
    /**
     * URL to tournament stream (Twitch, YouTube, etc.)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    streamUrl?: string;
    /**
     * Discord server invite URL
     * @type {string}
     * @memberof CreateTournamentBody
     */
    discordUrl?: string;
    /**
     * Contact email for tournament inquiries
     * @type {string}
     * @memberof CreateTournamentBody
     */
    contactEmail?: string;
    /**
     * Tournament banner/image URL
     * @type {string}
     * @memberof CreateTournamentBody
     */
    imageUrl?: string;
    /**
     * Tournament category type
     * @type {string}
     * @memberof CreateTournamentBody
     */
    category?: CreateTournamentBodyCategoryEnum;
    /**
     * Best of X series (1, 3, 5, etc.)
     * @type {number}
     * @memberof CreateTournamentBody
     */
    bestOf?: number;
    /**
     * Minutes after registration closes that late registration is allowed
     * @type {number}
     * @memberof CreateTournamentBody
     */
    lateRegistrationMinutes?: number;
    /**
     * Whether tournament is featured/pinned
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    featured?: boolean;
    /**
     * Unix timestamp (ms) until which tournament is featured
     * @type {number}
     * @memberof CreateTournamentBody
     */
    featuredUntil?: number;
    /**
     * Custom labels for prize placements - keys are placement numbers, values are labels
     * @type {{ [key: string]: string; }}
     * @memberof CreateTournamentBody
     */
    customPrizeLabels?: { [key: string]: string; };
    /**
     * Skip third place match in bracket
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    skipConsolationRound?: boolean;
    /**
     * Skip grand final bracket reset in double elimination
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    skipGrandFinalComeback?: boolean;
    /**
     * Skip secondary final match
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    skipSecondaryFinal?: boolean;
    /**
     * Multiple platforms allowed (for cross-platform tournaments)
     * @type {Array<string>}
     * @memberof CreateTournamentBody
     */
    platforms?: Array<string>;
    /**
     * Multiple regions allowed
     * @type {Array<string>}
     * @memberof CreateTournamentBody
     */
    regions?: Array<string>;
    /**
     * Whether this is a recurring tournament
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    isRecurring?: boolean;
    /**
     * Cron-style schedule for recurring tournaments
     * @type {string}
     * @memberof CreateTournamentBody
     */
    recurringSchedule?: string;
    /**
     * IANA timezone the recurringSchedule's time is interpreted in (default UTC)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    recurringTimezone?: string;
    /**
     * Whether clan tag is required for registration
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    clanTagRequired?: boolean;
    /**
     * Required format for clan tags
     * @type {string}
     * @memberof CreateTournamentBody
     */
    clanTagFormat?: string;
    /**
     * Reference to MatchMode
     * @type {string}
     * @memberof CreateTournamentBody
     */
    matchModeId?: string;
    /**
     * Reference to SubMode
     * @type {string}
     * @memberof CreateTournamentBody
     */
    subModeId?: string;
    /**
     * Password for private tournaments
     * @type {string}
     * @memberof CreateTournamentBody
     */
    password?: string;
    /**
     * Anti-cheat requirements (e.g., "FACEIT AC required")
     * @type {string}
     * @memberof CreateTournamentBody
     */
    antiCheat?: string;
    /**
     * Eligibility requirements text
     * @type {string}
     * @memberof CreateTournamentBody
     */
    eligibility?: string;
    /**
     * Ruleset name or identifier
     * @type {string}
     * @memberof CreateTournamentBody
     */
    ruleset?: string;
    /**
     * URL to full tournament rules
     * @type {string}
     * @memberof CreateTournamentBody
     */
    rulesUrl?: string;
    /**
     * Additional platform-specific notes
     * @type {string}
     * @memberof CreateTournamentBody
     */
    platformNotes?: string;
    /**
     * MongoDB ObjectId reference to a RuleSet from the rules library (triggers usage count tracking)
     * @type {string}
     * @memberof CreateTournamentBody
     */
    ruleSetId?: string;
    /**
     * MongoDB ObjectId reference to a ScoringTemplate for this tournament
     * @type {string}
     * @memberof CreateTournamentBody
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof CreateTournamentBody
     */
    scoringMode?: MatchScoringMode;
    /**
     * MongoDB ObjectId reference to a BracketTemplate (bracket blueprint/config) for this tournament
     * @type {string}
     * @memberof CreateTournamentBody
     */
    bracketTemplateId?: string;
    /**
     * If true, tournament starts automatically when registration closes and all teams are ready
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    autoStartEnabled?: boolean;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof CreateTournamentBody
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * IDs of EventPipelineFilter documents to apply to this tournament's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof CreateTournamentBody
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass exclusions of GLOBAL filters for this tournament (PRODUCT_PLAN D2(b)). excludedBy and excludedAt are stamped server-side and ignored if sent.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof CreateTournamentBody
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this tournament still scores events whose match context is missing. Default false — a tournament that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    failOpenOnMissingContext?: boolean;
    /**
     * Cheat-filtering match-bracketing gate. When true, scoring events fired outside Match Start / Round Start are dropped.
     * @type {boolean}
     * @memberof CreateTournamentBody
     */
    requireActiveMatch?: boolean;
    /**
     * Registration eligibility requirements (level / token balance / subscription tier / etc.)
     * @type {Array<Prerequisite>}
     * @memberof CreateTournamentBody
     */
    prerequisites?: Array<Prerequisite>;
}


/**
 * @export
 */
export const CreateTournamentBodyPlatformEnum = {
    PC: 'PC',
    CONSOLE: 'CONSOLE',
    MOBILE: 'MOBILE',
    CROSS_PLATFORM: 'CROSS_PLATFORM'
} as const;
export type CreateTournamentBodyPlatformEnum = typeof CreateTournamentBodyPlatformEnum[keyof typeof CreateTournamentBodyPlatformEnum];

/**
 * @export
 */
export const CreateTournamentBodyRegionEnum = {
    NA: 'NA',
    EU: 'EU',
    APAC: 'APAC',
    SA: 'SA',
    OCE: 'OCE',
    GLOBAL: 'GLOBAL'
} as const;
export type CreateTournamentBodyRegionEnum = typeof CreateTournamentBodyRegionEnum[keyof typeof CreateTournamentBodyRegionEnum];

/**
 * @export
 */
export const CreateTournamentBodyPrivacyEnum = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    INVITE_ONLY: 'INVITE_ONLY'
} as const;
export type CreateTournamentBodyPrivacyEnum = typeof CreateTournamentBodyPrivacyEnum[keyof typeof CreateTournamentBodyPrivacyEnum];

/**
 * @export
 */
export const CreateTournamentBodySkillLevelEnum = {
    OPEN: 'OPEN',
    BEGINNER: 'BEGINNER',
    INTERMEDIATE: 'INTERMEDIATE',
    ADVANCED: 'ADVANCED',
    PRO: 'PRO'
} as const;
export type CreateTournamentBodySkillLevelEnum = typeof CreateTournamentBodySkillLevelEnum[keyof typeof CreateTournamentBodySkillLevelEnum];

/**
 * @export
 */
export const CreateTournamentBodyCategoryEnum = {
    TOURNAMENT: 'TOURNAMENT',
    MONEY_MATCH: 'MONEY_MATCH',
    LEAGUE: 'LEAGUE',
    SCRIMMAGE: 'SCRIMMAGE',
    QUALIFIER: 'QUALIFIER'
} as const;
export type CreateTournamentBodyCategoryEnum = typeof CreateTournamentBodyCategoryEnum[keyof typeof CreateTournamentBodyCategoryEnum];


/**
 * Check if a given object implements the CreateTournamentBody interface.
 */
export function instanceOfCreateTournamentBody(value: object): value is CreateTournamentBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('bracketType' in value) || value['bracketType'] === undefined) return false;
    if (!('teamSize' in value) || value['teamSize'] === undefined) return false;
    if (!('maxTeams' in value) || value['maxTeams'] === undefined) return false;
    if (!('registrationOpens' in value) || value['registrationOpens'] === undefined) return false;
    if (!('registrationCloses' in value) || value['registrationCloses'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function CreateTournamentBodyFromJSON(json: any): CreateTournamentBody {
    return CreateTournamentBodyFromJSONTyped(json, false);
}

export function CreateTournamentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTournamentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'bracketType': BracketTypeFromJSON(json['bracketType']),
        'teamSize': json['teamSize'],
        'maxTeams': json['maxTeams'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'entryType': json['entryType'] == null ? undefined : CompetitionEntryTypeFromJSON(json['entryType']),
        'entryFeeConfig': json['entryFeeConfig'] == null ? undefined : EntryFeeConfigFromJSON(json['entryFeeConfig']),
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'prizePool': json['prizePool'] == null ? undefined : TournamentPrizePoolInputFromJSON(json['prizePool']),
        'registrationOpens': json['registrationOpens'],
        'registrationCloses': json['registrationCloses'],
        'startTime': json['startTime'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'bracketSettings': json['bracketSettings'] == null ? undefined : TournamentBracketSettingsInputFromJSON(json['bracketSettings']),
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'entryFeeCurrency': json['entryFeeCurrency'] == null ? undefined : TournamentCurrencyFromJSON(json['entryFeeCurrency']),
        'entryFeeUnit': json['entryFeeUnit'] == null ? undefined : EntryFeeUnitFromJSON(json['entryFeeUnit']),
        'allowedFeeModes': json['allowedFeeModes'] == null ? undefined : ((json['allowedFeeModes'] as Array<any>).map(TournamentFeeModeFromJSON)),
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'prizeSplit': json['prizeSplit'] == null ? undefined : TournamentPrizeSplitFromJSON(json['prizeSplit']),
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'jurisdictionPolicyId': json['jurisdictionPolicyId'] == null ? undefined : json['jurisdictionPolicyId'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'region': json['region'] == null ? undefined : json['region'],
        'privacy': json['privacy'] == null ? undefined : json['privacy'],
        'skillLevel': json['skillLevel'] == null ? undefined : json['skillLevel'],
        'ageRestriction': json['ageRestriction'] == null ? undefined : json['ageRestriction'],
        'checkInRequired': json['checkInRequired'] == null ? undefined : json['checkInRequired'],
        'checkInWindowMinutes': json['checkInWindowMinutes'] == null ? undefined : json['checkInWindowMinutes'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'category': json['category'] == null ? undefined : json['category'],
        'bestOf': json['bestOf'] == null ? undefined : json['bestOf'],
        'lateRegistrationMinutes': json['lateRegistrationMinutes'] == null ? undefined : json['lateRegistrationMinutes'],
        'featured': json['featured'] == null ? undefined : json['featured'],
        'featuredUntil': json['featuredUntil'] == null ? undefined : json['featuredUntil'],
        'customPrizeLabels': json['customPrizeLabels'] == null ? undefined : json['customPrizeLabels'],
        'skipConsolationRound': json['skipConsolationRound'] == null ? undefined : json['skipConsolationRound'],
        'skipGrandFinalComeback': json['skipGrandFinalComeback'] == null ? undefined : json['skipGrandFinalComeback'],
        'skipSecondaryFinal': json['skipSecondaryFinal'] == null ? undefined : json['skipSecondaryFinal'],
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'regions': json['regions'] == null ? undefined : json['regions'],
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurringSchedule': json['recurringSchedule'] == null ? undefined : json['recurringSchedule'],
        'recurringTimezone': json['recurringTimezone'] == null ? undefined : json['recurringTimezone'],
        'clanTagRequired': json['clanTagRequired'] == null ? undefined : json['clanTagRequired'],
        'clanTagFormat': json['clanTagFormat'] == null ? undefined : json['clanTagFormat'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'subModeId': json['subModeId'] == null ? undefined : json['subModeId'],
        'password': json['password'] == null ? undefined : json['password'],
        'antiCheat': json['antiCheat'] == null ? undefined : json['antiCheat'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'ruleset': json['ruleset'] == null ? undefined : json['ruleset'],
        'rulesUrl': json['rulesUrl'] == null ? undefined : json['rulesUrl'],
        'platformNotes': json['platformNotes'] == null ? undefined : json['platformNotes'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'bracketTemplateId': json['bracketTemplateId'] == null ? undefined : json['bracketTemplateId'],
        'autoStartEnabled': json['autoStartEnabled'] == null ? undefined : json['autoStartEnabled'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
    };
}

export function CreateTournamentBodyToJSON(json: any): CreateTournamentBody {
    return CreateTournamentBodyToJSONTyped(json, false);
}

export function CreateTournamentBodyToJSONTyped(value?: CreateTournamentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challengeId': value['challengeId'],
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'bracketType': BracketTypeToJSON(value['bracketType']),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'entryFeeConfig': EntryFeeConfigToJSON(value['entryFeeConfig']),
        'minParticipants': value['minParticipants'],
        'entryFee': value['entryFee'],
        'prizePool': TournamentPrizePoolInputToJSON(value['prizePool']),
        'registrationOpens': value['registrationOpens'],
        'registrationCloses': value['registrationCloses'],
        'startTime': value['startTime'],
        'rules': value['rules'],
        'bracketSettings': TournamentBracketSettingsInputToJSON(value['bracketSettings']),
        'competitionId': value['competitionId'],
        'brandId': value['brandId'],
        'entryFeeCurrency': TournamentCurrencyToJSON(value['entryFeeCurrency']),
        'entryFeeUnit': EntryFeeUnitToJSON(value['entryFeeUnit']),
        'allowedFeeModes': value['allowedFeeModes'] == null ? undefined : ((value['allowedFeeModes'] as Array<any>).map(TournamentFeeModeToJSON)),
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'prizeSplit': TournamentPrizeSplitToJSON(value['prizeSplit']),
        'payoutTableId': value['payoutTableId'],
        'jurisdictionPolicyId': value['jurisdictionPolicyId'],
        'platform': value['platform'],
        'region': value['region'],
        'privacy': value['privacy'],
        'skillLevel': value['skillLevel'],
        'ageRestriction': value['ageRestriction'],
        'checkInRequired': value['checkInRequired'],
        'checkInWindowMinutes': value['checkInWindowMinutes'],
        'streamUrl': value['streamUrl'],
        'discordUrl': value['discordUrl'],
        'contactEmail': value['contactEmail'],
        'imageUrl': value['imageUrl'],
        'category': value['category'],
        'bestOf': value['bestOf'],
        'lateRegistrationMinutes': value['lateRegistrationMinutes'],
        'featured': value['featured'],
        'featuredUntil': value['featuredUntil'],
        'customPrizeLabels': value['customPrizeLabels'],
        'skipConsolationRound': value['skipConsolationRound'],
        'skipGrandFinalComeback': value['skipGrandFinalComeback'],
        'skipSecondaryFinal': value['skipSecondaryFinal'],
        'platforms': value['platforms'],
        'regions': value['regions'],
        'isRecurring': value['isRecurring'],
        'recurringSchedule': value['recurringSchedule'],
        'recurringTimezone': value['recurringTimezone'],
        'clanTagRequired': value['clanTagRequired'],
        'clanTagFormat': value['clanTagFormat'],
        'matchModeId': value['matchModeId'],
        'subModeId': value['subModeId'],
        'password': value['password'],
        'antiCheat': value['antiCheat'],
        'eligibility': value['eligibility'],
        'ruleset': value['ruleset'],
        'rulesUrl': value['rulesUrl'],
        'platformNotes': value['platformNotes'],
        'ruleSetId': value['ruleSetId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'bracketTemplateId': value['bracketTemplateId'],
        'autoStartEnabled': value['autoStartEnabled'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'requireActiveMatch': value['requireActiveMatch'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
    };
}

